import Service 				from "./../../Libs/Service";
import { Settings } 		from "./Settings";
import { Version } 			from "./Version";
import { Elements } 		from "@/services/Elements";
import { Layout } 			from "@/services/Layout";
import { ScreenService } 	from "@/services/Screen";

let Renderer = new Service({

	Name: "Renderer",

	Libraries: [],

	Events: {

		// Смена вкладки настроек версии креатива
		"Settings Tab Changed": function(tabName, prevTabName) {

			// Если включается вкладка с редактором дерева элементов
			if (tabName === 'elements') {

				//Без тайм-аута компонент не успевает срендериться и ScreenService.SelectedScreen?.codename === null;
				setTimeout(() => this.activateSceneEditor(), 200);

			} else if (prevTabName === 'elements' || Elements.SelectedElement) {

				this.deactivateSceneEditor();

			}

		},

		// Редактор в превью должен работать только при открытой панели настроек на вкладке редактора элементов
		"Aside State Changed": function() {

			if (Layout.settingsTabName !== 'elements') return;

			if (Layout.asideOpened) setTimeout(() => this.activateSceneEditor(), 200);
			else this.deactivateSceneEditor();

		},

		"IFrame Data:AppScreensCreated": function() {

			Broadcast.call("Send To iFrame", [{
				SceneEditor: Layout.asideOpened && Layout.settingsTabName === 'elements',
				SceneEditorScreen: ScreenService.SelectedScreen?.codename,
				SceneEditorModes: this.modes,
				ElementPropertiesByCodename: Metadata.ElementPropertiesByCodename
			}]);

		}

	},

	Actions: {

		//Получение креативов текущего издателя
		'HTMLRendererScriptChanged': function() {

			if (Creative.SelectedCreative?.type === 'end-card' || Creative.SelectedCreative?.type === 'banner' || Creative.SelectedCreative?.type === 'storyboard') {

				Broadcast.call("Selected Creative Renderer Script Changed");

			}

		},

		// Редактируемые плейаблы используют сборку MraidSDK с PixiRenderer
		'PixiRendererScriptChanged': function() {

			if (Creative.SelectedCreative?.type === 'editable-playable') {

				Broadcast.call("Selected Creative Renderer Script Changed");

			}

		}

	},

	init() {

		this.modes = {
			'select-by-click': true,
			'move-by-drag': true
		};

	},

	getEndCardVersion(creative, version) {

		if (!creative || !version) return null;
		if (creative.type !== 'playable') return null;

		let endCardVersionId = Settings.getVersionSettingValue(version.id, 'end-card-version-id');
		return Version.getVersion(endCardVersionId) || null;

	},

	activateSceneEditor() {

		Broadcast.call("Send To iFrame", [{
			SceneEditor: true,
			SceneEditorScreen: ScreenService.SelectedScreen?.codename,
			SceneEditorModes: this.modes,
			ElementPropertiesByCodename: Metadata.ElementPropertiesByCodename
		}]);

	},

	deactivateSceneEditor() {

		// Сбрасываем выделенный элемент при уходе с вкладки редактора или закрытии панели настроек
		let screenCodename = ScreenService.SelectedScreen?.codename || Elements.SelectedElement?.['screen_codename'];

		Elements.selectElement(null);

		Broadcast.call("Send To iFrame", [{
			SelectElement: [screenCodename, null],
			SceneEditor: false
		}]);

	},

	toggleMode(modeCodename) {

		this.modes[modeCodename] = !this.modes[modeCodename];

		Broadcast.call("Editor Modes Changed");

		Broadcast.call("Send To iFrame", [{
			SceneEditorModes: this.modes
		}]);

	}

});

window.Renderer = Renderer;

export { Renderer }

